"use strict";

(function () {
  angular.module('lif.controllers').controller('catalogStructureWithFileBlockController', catalogStructureWithFileBlockController);
  catalogStructureWithFileBlockController.$inject = ['$scope', '$window', '$timeout', 'formService', 'catalogStructureWithFileBlockFactory'];

  function catalogStructureWithFileBlockController($scope, $window, $timeout, formService, factoryData) {
    var vm = this;
    var ItemType = {
      Folder: 0,
      File: 1
    };
    vm.isBusy = false;
    vm.isUploading = false;
    vm.creatingFolder = false;
    vm.rootFolder = {};
    vm.deletingFile = false;
    vm.isEditable = factoryData.isEditable.toLowerCase() === 'true';
    vm.maximumAmountOfFoldersToShow = 100;
    vm.movingItem = null;
    vm.isMovingFolder = false;
    vm.isMovingFile = false;
    $scope.alerts = [];
    $scope.toggle = [];
    $scope.isMouseOver = [];
    $scope.isMouseOverFile = [];
    $scope.selectedFile = null;
    $scope.selectedFolder = null;
    $scope.shownDropDownMenuId = null;
    $scope.shownModalId = null;
    $scope.movingItemId = null;
    var startingFoldersAmount = null;

    $scope.isMovingAnything = function () {
      return vm.isMovingFile || vm.isMovingFolder;
    };
    /*-- Private functions --*/


    var resetDropDownMenu = function resetDropDownMenu() {
      $scope.shownDropDownMenuId = null;
    };

    var checkThatFolderIsOpenOtherwiseOpen = function checkThatFolderIsOpenOtherwiseOpen(folder) {
      if (!$scope.toggle[folder.Id]) {
        $scope.toggle[folder.Id] = true;
      }
    };

    var addAlert = function addAlert(alert) {
      $scope.alerts.push(alert);

      var timeoutFunc = function (obj) {
        return function () {
          var index = $scope.alerts.indexOf(obj);
          if (index >= 0) $scope.alerts.splice(index, 1);
        };
      }(alert);

      $timeout(timeoutFunc, 10000);
    };

    var getFolderCreateModalName = function getFolderCreateModalName(id) {
      resetDropDownMenu();
      return "#folderCreateModal-" + id;
    };

    var getFolderRemoveModalName = function getFolderRemoveModalName(id) {
      resetDropDownMenu();
      return "#folderRemoveModal-" + id;
    };

    var getFileRemoveModalName = function getFileRemoveModalName(id) {
      resetDropDownMenu();
      return "#fileRemoveModal-" + id;
    };

    var getFolderEditModalName = function getFolderEditModalName(id) {
      resetDropDownMenu();
      return '#folderEditModal-' + id;
    };

    var clearSelections = function clearSelections() {
      $scope.selectedFolder = null;
      $scope.selectedFile = null;
      $scope.shownDropDownMenuId = null;
      $scope.shownModalId = null;
      $scope.movingItemId = null;
    };

    var isChildOfFolder = function isChildOfFolder(folder, folders) {
      if (!folder || !folders) return false;
      var result = false;
      folders.some(function (item) {
        if (folder.Id === item.Id) {
          result = true;
          return true;
        }

        if (item.Folders) {
          result = isChildOfFolder(folder, item.Folders);

          if (result) {
            return true;
          }
        }
      });
      return result;
    };

    var folderExistsInFolder = function folderExistsInFolder(sourceFolder, destinationFolder) {
      if (!destinationFolder || !destinationFolder.Folders) return false;
      var result = false;
      destinationFolder.Folders.some(function (item) {
        if (sourceFolder.Id === item.Id) {
          result = true;
          return;
        }
      });
      return result;
    };

    var findParentFolder = function findParentFolder(folder, folders) {
      var result = null;
      folders.some(function (itm) {
        if (folderExistsInFolder(folder, itm)) {
          result = itm;
          return true;
        }

        if (itm.Folders) {
          result = findParentFolder(folder, itm.Folders);

          if (result) {
            return true;
          }
        }
      });
      return result;
    };

    var isRootFolder = function isRootFolder(folder, folders) {
      var result = null;
      folders.some(function (itm) {
        if (folder.Id === itm.Id) {
          result = itm;
          return true;
        }
      });
      return result;
    };

    var traverseDeleteFile = function traverseDeleteFile(folders, id) {
      for (var i = 0; i < folders.length; i++) {
        var f = folders[i];

        if (f.Files !== undefined && f.Files.length > 0) {
          for (var x = 0; x < f.Files.length; x++) {
            var file = f.Files[x];

            if (file.ContentId === id) {
              f.Files.splice(x, 1);
              return;
            }
          }
        }

        if (f.Folders !== undefined && f.Folders.length > 0) {
          traverseDeleteFile(f.Folders, id);
        }
      }
    };

    var createNewEmptyFolder = function createNewEmptyFolder(id, name) {
      return {
        Id: id,
        Name: name,
        Folders: [],
        Files: []
      };
    };

    var toFileObjectFromResult = function toFileObjectFromResult(result) {
      return {
        Title: result.FileName,
        Date: result.Date,
        ContentId: result.ContentId,
        Url: result.Url
      };
    };
    /*-- End private functions --*/


    $(function () {
      $(getFolderCreateModalName(vm.rootFolder.Id)).on("hidden.bs.modal", function () {
        vm.creatingFolder = false;
        clearSelections();
        $scope.$apply();
      });
      $(getFolderRemoveModalName(vm.rootFolder.Id)).on("hidden.bs.modal", function () {
        clearSelections();
        $scope.$apply();
      });
      $(getFileRemoveModalName(vm.rootFolder.Id)).on("hidden.bs.modal", function () {
        clearSelections();
        $scope.$apply();
      });
      $(getFolderEditModalName(vm.rootFolder.Id)).on("hidden.bs.modal", function () {
        clearSelections();
        $scope.$apply();
      });
      $(".dropdown-burger").on("hidden.bs.dropdown", function () {
        resetDropDownMenu();
        $scope.$apply();
      });
    });

    vm.getFileTypeIcon = function (fileName) {
      return fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase() + '.png';
    };

    vm.showMoreFolders = function () {
      if (!startingFoldersAmount) {
        startingFoldersAmount = vm.numberOfFoldersToShow;
      }

      if (vm.numberOfFoldersToShow === startingFoldersAmount) {
        vm.numberOfFoldersToShow = vm.maximumAmountOfFoldersToShow;
      } else {
        vm.numberOfFoldersToShow = startingFoldersAmount;
      }
    };

    vm.addFile = function () {
      $timeout(function () {
        resizeLeftNavbar();
      }, 200);
    };

    $scope.toggleFolder = function (id) {
      if (!$scope.toggle[id]) {
        $scope.toggle[id] = true;
      } else {
        $scope.toggle[id] = !$scope.toggle[id];
      }
    };

    vm.startMoveFolderMode = function (folder) {
      $scope.movingItemId = folder.Id;
      var parentFolder = findParentFolder(folder, vm.rootFolder.Folders);
      if (!parentFolder) parentFolder = vm.rootFolder;
      vm.movingItem = {
        type: ItemType.Folder,
        item: folder,
        currentFolder: parentFolder
      };
      vm.isMovingFolder = true;
    };

    vm.startMoveFileMode = function (file, folder) {
      $scope.movingItemId = file.ContentId;
      vm.movingItem = {
        type: ItemType.File,
        item: file,
        currentFolder: folder
      };
      vm.isMovingFile = true;
    };

    vm.abortMoveMode = function () {
      vm.movingItem = null;
      vm.isMovingFile = false;
      vm.isMovingFolder = false;
      $scope.movingItemId = null;
    };

    vm.isMovableHere = function (folder) {
      if (!folder || !vm.movingItem) return false;
      if (vm.movingItem.currentFolder && folder.Id === vm.movingItem.currentFolder.Id) return false;

      if (vm.movingItem.type === ItemType.File) {
        return true;
      } else if (vm.movingItem.type === ItemType.Folder) {
        if (folder.Id === vm.movingItem.item.Id) return false;
        if (folder === vm.rootFolder && vm.movingItem.currentFolder === vm.rootFolder) return true;
        return !isChildOfFolder(folder, vm.movingItem.item.Folders);
      }

      return false;
    };

    vm.moveItemToFolder = function (destinationFolder) {
      if (!vm.movingItem || !destinationFolder || !vm.isMovableHere(destinationFolder)) {
        clearSelections();
        return false;
      }

      vm.isBusy = true;

      if (vm.movingItem.type === ItemType.Folder) {
        formService.moveFolder(vm.movingItem.item.Id, destinationFolder.Id, factoryData.folderMoveUrl).then(function () {
          checkThatFolderIsOpenOtherwiseOpen(destinationFolder);
          vm.movingItem.currentFolder.Folders.splice(vm.movingItem.currentFolder.Folders.findIndex(function (folder) {
            return folder.Id === vm.movingItem.item.Id;
          }), 1);
          destinationFolder.Folders.unshift(vm.movingItem.item);
          vm.abortMoveMode();
          vm.isBusy = false;
        }, function () {
          //error
          addAlert(factoryData.errors.generic);
          vm.isBusy = false;
        });
      } else if (vm.movingItem.type === ItemType.File) {
        formService.moveFile(vm.movingItem.item.ContentId, destinationFolder.Id, factoryData.fileMoveUrl).then(function () {
          checkThatFolderIsOpenOtherwiseOpen(destinationFolder);
          vm.movingItem.currentFolder.Files.splice(vm.movingItem.currentFolder.Files.findIndex(function (file) {
            return file.ContentId === vm.movingItem.item.ContentId;
          }), 1);
          destinationFolder.Files.unshift(vm.movingItem.item);
          vm.abortMoveMode();
          vm.isBusy = false;
        }, function () {
          //error
          addAlert(factoryData.errors.generic);
          vm.isBusy = false;
        });
      }
    };

    vm.changeFolderName = function (newFolderName) {
      if (!$scope.selectedFolder) {
        clearSelections();
        return;
      }

      vm.isBusy = true;
      formService.changeFolderName($scope.selectedFolder.Id, factoryData.folderRenameUrl, newFolderName).then(function () {
        $(getFolderEditModalName(vm.rootFolder.Id)).modal("hide");
        $scope.selectedFolder.Name = newFolderName;
        $scope.inputFolderName = null;
        clearSelections();
        vm.isBusy = false;
      }, function () {
        //error
        $scope.inputFolderName = null;
        addAlert(factoryData.errors.generic);
        vm.isBusy = false;
      });
    };

    vm.createFolder = function (folderName, parentFolder) {
      vm.creatingFolder = true;
      vm.isBusy = true;
      formService.createSubFolder(folderName, vm.rootFolder.Id, factoryData.folderUrl, parentFolder.Id).then(function (contentId) {
        $(getFolderCreateModalName(vm.rootFolder.Id)).modal("hide");

        if (parentFolder) {
          checkThatFolderIsOpenOtherwiseOpen(parentFolder);
          parentFolder.Folders.unshift(createNewEmptyFolder(contentId, folderName));
        } else {
          vm.rootFolder.Folders.unshift(createNewEmptyFolder(contentId, folderName));
        }

        vm.creatingFolder = false;
        $scope.inputFolderName = null;
        clearSelections();
        vm.isBusy = false;
      }, function () {
        //error
        vm.creatingFolder = false;
        $scope.inputFolderName = null;
        addAlert(factoryData.errors.generic);
        vm.isBusy = false;
      });
    };
    /*-- MODALS --*/


    vm.showRemoveFileModal = function (file, folder) {
      $scope.selectedFile = file;
      $scope.selectedFolder = folder;
      $scope.shownModalId = file.ContentId;
      $(getFileRemoveModalName(vm.rootFolder.Id)).modal("show");
    };

    vm.showRemoveFolderModal = function (folder) {
      $scope.selectedFolder = folder;
      $scope.shownModalId = folder.Id;
      $(getFolderRemoveModalName(vm.rootFolder.Id)).modal("show");
    };

    vm.showRenameFolderModal = function (folder) {
      $scope.selectedFolder = folder;
      $scope.shownModalId = folder.Id;
      $scope.inputFolderName = folder.Name;
      $(getFolderEditModalName(vm.rootFolder.Id)).modal("show");
    };

    vm.showAddFolderModal = function (folder) {
      $scope.selectedFolder = folder;
      $scope.shownModalId = folder.Id;
      $scope.inputFolderName = factoryData.newFolderDefaultName;
      $(getFolderCreateModalName(vm.rootFolder.Id)).modal("show");
    };
    /*-- /MODALS --*/

    /*-- DROP DOWNS --*/


    vm.showFolderDropDown = function (folder) {
      $scope.selectedFolder = folder;
      $scope.shownDropDownMenuId = folder.Id;
    };

    vm.showFileDropDown = function (file) {
      $scope.selectedFile = file;
      $scope.shownDropDownMenuId = file.ContentId;
    };
    /*-- /DROP DOWNS --*/


    vm.openFile = function (file) {
      $window.open(file.Url, "_blank");
    };

    vm.confirmedRemoveFolder = function () {
      if (!$scope.selectedFolder) {
        clearSelections();
        return;
      }

      vm.deletingFolder = true;
      formService.deleteFolder(factoryData.folderRemoveUrl, $scope.selectedFolder.Id).then(function (result) {
        var isRoot = isRootFolder($scope.selectedFolder, vm.rootFolder.Folders);

        if (isRoot) {
          vm.rootFolder.Folders.splice(vm.rootFolder.Folders.findIndex(function (itm) {
            return itm.Id === $scope.selectedFolder.Id;
          }), 1);
        } else {
          var parentFolder = findParentFolder($scope.selectedFolder, vm.rootFolder.Folders);

          if (parentFolder.Folders.some) {
            parentFolder.Folders.splice(parentFolder.Folders.findIndex(function (itm) {
              return itm.Id === $scope.selectedFolder.Id;
            }), 1);
          }
        }

        clearSelections();
        vm.deletingFolder = false;
        $(getFolderRemoveModalName(vm.rootFolder.Id)).modal("hide");
      }, function () {
        //error
        clearSelections();
        vm.deletingFolder = false;
        $(getFolderRemoveModalName(vm.rootFolder.Id)).modal("hide");
        addAlert(factoryData.errors.generic);
      });
    };

    vm.removeFile = function () {
      if (!$scope.selectedFile) {
        clearSelections();
        return;
      }

      vm.deletingFile = true;
      formService.deleteFile(factoryData.deleteUrl, $scope.selectedFile.ContentId).then(function (result) {
        traverseDeleteFile(vm.rootFolder.Folders, $scope.selectedFile.ContentId);
        $(getFileRemoveModalName(vm.rootFolder.Id)).modal("hide");
        clearSelections();
        vm.deletingFile = false;
      }, function () {
        //error
        $(getFileRemoveModalName(vm.rootFolder.Id)).modal("hide");
        addAlert(factoryData.errors.generic);
        clearSelections();
        vm.deletingFile = false;
      });
    };

    vm.upload = function ($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
      if (!$files && $files.length <= 0) {
        clearSelections();
        return;
      }

      vm.isUploading = true;
      formService.uploadFiles($files, factoryData.url, $scope.selectedFolder.Id).then(function (results) {
        vm.isUploading = false;

        if (!$scope.selectedFolder.Files) {
          $scope.selectedFolder.Files = [];
        }

        results.forEach(function (r) {
          $scope.selectedFolder.Files.unshift(toFileObjectFromResult(r));
        });
        checkThatFolderIsOpenOtherwiseOpen($scope.selectedFolder);
        clearSelections();
      }, function () {
        //error
        vm.isUploading = false;
        addAlert(factoryData.errors.generic);
        clearSelections();
      });
    };
  }
})();